import { diaNegocio, hora12, nombreServicios, serviciosDe, sumarDias, type AgendaDia, type CitaVista } from '@barbones/shared';
import { useQueries } from '@tanstack/react-query';
import { api } from '@/api/cliente';
import { Esqueleto, Tarjeta } from '@/components/ui/data';
import { cn, diaLargo } from '@/lib/utils';
import { CLASES_TARJETA } from './EstadoCita';
import { EtiquetaPago } from './EtiquetaPago';

/** Semana de 7 columnas: cada día lista sus citas (sin cancelaciones) y lleva a su vista Día. */
export function VistaSemana({ semana, onCita, onDia }: { semana: string; onCita: (c: CitaVista) => void; onDia: (d: string) => void }) {
  const dias = Array.from({ length: 7 }, (_, i) => sumarDias(semana, i));
  const hoy = diaNegocio(new Date());
  const consultas = useQueries({
    queries: dias.map((d) => ({ queryKey: ['agenda', 'dia', d], queryFn: () => api<AgendaDia>('/agenda/dia', { query: { dia: d } }) })),
  });
  return (
    <div className="grid gap-2 md:grid-cols-7">
      {dias.map((d, i) => {
        const citas = (consultas[i]?.data?.citas ?? []).filter((c) => c.estado !== 'cancelada');
        return (
          <Tarjeta key={d} className={cn('min-h-40 p-2', d === hoy && 'border-accent ring-1 ring-accent/40')}>
            <button type="button" onClick={() => onDia(d)} className="mb-2 w-full rounded px-1 text-left hover:bg-muted">
              <p className="text-[11px] uppercase tracking-wide text-foreground-muted">{diaLargo(d).split(',')[0]}</p>
              <p className="cifras font-display text-[20px] leading-none">{d.slice(8)}</p>
            </button>
            <ul className="flex flex-col gap-1">
              {citas.map((c) => (
                <li key={c.id}>
                  <button
                    type="button"
                    onClick={() => onCita(c)}
                    className={cn('w-full rounded border border-border/50 border-l-[3px] px-1.5 py-1 text-left text-[11.5px]', CLASES_TARJETA[c.estado])}
                  >
                    <span className="cifras font-semibold">{hora12(new Date(c.inicio))}</span> {c.cliente.nombre}
                    <span className="block truncate text-foreground-muted">{nombreServicios(serviciosDe(c), true)}</span>
                    <span className="flex items-center justify-between gap-1">
                      <span className="truncate text-foreground-muted">{c.barbero ?? 'Sin asignar'}</span>
                      <EtiquetaPago metodos={c.metodosPago} compacta />
                    </span>
                  </button>
                </li>
              ))}
              {consultas[i]?.isLoading && <Esqueleto className="h-8" />}
            </ul>
          </Tarjeta>
        );
      })}
    </div>
  );
}
